import { FxTranslate } from "../../../core/translate";
import API from "../../../services/api";
import { ICardEdit } from "../../../services/operaciones/model/ICardEdit";
import Security from "../../../services/seguridad";
import Alert from "../../alerts";

export class CalcClass {
  private onUpdateFields: (updates: { field: string, value: any }[]) => void = () => {};
  private TazaConversion?: number;
  public IdMoneda?: number;
  public IdCliente?: number;
  public IdProveedor?: number;
  private ClienteProveedorComision?: number;

  constructor(onUpdateFields: (updates: { field: string, value: any }[]) => void) {
    this.onUpdateFields = onUpdateFields;
  }

  public setOnUpdateFields = (onUpdateFields: (updates: { field: string, value: any }[]) => void) => this.onUpdateFields = onUpdateFields;

  /** indica si el servicio está listo para calcular */
  public isValid = () => !!this.TazaConversion;

  /** avisa cuando se cambia una moneda para actualizar la taza de conversion */
  public changeMoneda = (idMoneda: number, t: FxTranslate, data: ICardEdit | undefined | null) => {
    console.log("changeMoneda", idMoneda, Security.User?.descuentoAutorizado)
    const firstTime = !this.IdMoneda;
    this.IdMoneda = idMoneda;
    this.TazaConversion = undefined;
    return API.CobranzaController().Moneda().getEdit({ id: idMoneda }).then(res => {
      if (!res.success) return Alert.reponse(res);
      this.setTazaConversion(res.data?.usd ?? 0);
      if (!firstTime) this._recalcAllFromUSD(idMoneda, t, data);
    }).catch(ex => Alert.exception(t, ex))
  }

  /** establece la taza de conversion */
  public setTazaConversion = (taza: number) => this.TazaConversion = taza;

  
  /** avisa cuando se cambia una moneda para actualizar la taza de conversion */
  public changeClienteProveedor = (idcliente: number, idproveedor: number, t: FxTranslate) => {
    console.log("changeClienteProveedor", idcliente, idproveedor);
    this.IdCliente = idcliente;
    this.IdProveedor = idproveedor;
    this.ClienteProveedorComision = undefined;
    API.ClientesController().Cliente().proveedor({ idCliente: this.IdCliente, idProveedor: this.IdProveedor }).then(res => {
      if (!res.success) return Alert.reponse(res);
      this.setClienteProveedorComision(res.data?.comision ?? 0);
    }).catch(ex => Alert.exception(t, ex))
  }
  /** establece la taza de conversion */
  public setClienteProveedorComision = (comision: number) => this.ClienteProveedorComision = comision;



  public changePagado(value: number, data: ICardEdit, t: FxTranslate) {
    console.log("changePagado", value)
    value = Math.round(100 * value) / 100;
    this._changeImporte("operacionpago.monto", value);
  }

  public changeDescuentoVendedor(porc: number | undefined, value: number | undefined, data: ICardEdit, t: FxTranslate) {
    if (value === undefined)
      value = Math.round((data.operacion?.total ?? 0) * (porc ?? 0)) / 100;
    else
      porc = Math.round(100 * 100 * value / (data.operacion?.total ?? 0)) / 100;

    console.log("changeDescuentoVendedor", value, porc, Security.User?.descuentoAutorizado)
    var montoMaximo = Math.round(100 * (data.operacion?.total ?? 0) * (Security.User?.descuentoAutorizado ?? 0) / 100) / 100;
    value = Math.round(100 * value) / 100;
    if (value > montoMaximo) {
      Alert.error(t("Seccion.Field.operacionpago.descuentovendedor.maxvalue"), t("Seccion.Field.operacionpago.descuentovendedor.maxvalue.desc", { max: montoMaximo }));
      value = montoMaximo;
      porc = (Security.User?.descuentoAutorizado ?? 0);
      $("#Board-Card-Seccion-OperacionPago-descuentovendedor").val(`${montoMaximo}`);
      $("#Board-Card-Seccion-OperacionPago-descuentovendedorporc").val(`${porc}`);
    }
    this._changeImporte("operacion.totaldescuentovendedor", value, porc);
  }

  public changeRedondeo(value: number, data: ICardEdit, t: FxTranslate) {
    console.log("changeRedondeo", value)
    var montoMaximo = Math.round(100 * (data.operacion?.total ?? 0) * 0.1) / 100;
    value = Math.round(100 * value) / 100;
    if (value > montoMaximo || value < -montoMaximo) {
      Alert.error(t("Seccion.Field.operacionpago.ajusteredondeo.maxvalue"), t("Seccion.Field.operacionpago.ajusteredondeo.maxvalue.desc", { min: -montoMaximo, max: montoMaximo }));
      value = value > montoMaximo ? montoMaximo : -montoMaximo;
      $("#Board-Card-Seccion-OperacionPago-ajusteredondeo").val(`${montoMaximo}`);
    }
    this._changeImporte("operacion.totalajusteredondeo", value);
  }

  public changeRedondeoUsd(value: number, data: ICardEdit, t: FxTranslate) {
    const ars = value * (this.TazaConversion ?? 1);
    return this.changeRedondeo(Math.round(100 * ars) / 100, data, t);
  }

  public changeComision(porc: number | undefined, value: number | undefined, data: ICardEdit, t: FxTranslate) {
    if (value === undefined)
      value = Math.round((data.operacion?.total ?? 0) * (porc ?? 0)) / 100;
    else
      porc = Math.round(100 * 100 * value / (data.operacion?.total ?? 0)) / 100;

    var montoMaximo = Math.round(100 * (data.operacion?.total ?? 0) * (this.ClienteProveedorComision ?? 0) / 100) / 100;
    value = Math.round(100 * value) / 100;
    if (value > montoMaximo) {
      Alert.error(t("Seccion.Field.operacionpago.descuentocomision.maxvalue"), t("Seccion.Field.operacionpago.descuentocomision.maxvalue.desc", { max: montoMaximo }));
      value = montoMaximo;
      porc = (this.ClienteProveedorComision ?? 0);
      $("#Board-Card-Seccion-OperacionPago-descuentocomision").val(`${montoMaximo}`);
      $("#Board-Card-Seccion-OperacionPago-descuentocomisionporc").val(`${porc}`);
    }
    this._changeImporte("operacion.totaldescuentocomision", value, porc);
  }

  public changeCuotasRecargo(porc: number | undefined, fieldname: string, value: number | undefined, data: ICardEdit, t: FxTranslate) {
    if (value === undefined)
      value = Math.round((data.operacion?.total ?? 0) * (porc ?? 0)) / 100;
    else {
      porc = Math.round(100 * 100 * value / (data.operacion?.total ?? 0)) / 100;
    }
    
    this._changeImporte(fieldname, value, porc);
  }

  private _changeImporte = (field: string, value: number, porc?: number) => {
    const usd = Math.round(100 * value / (this.TazaConversion ?? 1)) / 100;
    const updates = [
      { field: `${field}`, value: value },
      { field: `${field}usd`, value: usd },
    ];
    if (porc !== undefined) 
      updates.push({ field: `${field}porc`, value: porc });

    this.onUpdateFields(updates);
  }

  
  private _recalcAllFromUSD = (idMoneda: number, t: FxTranslate, data: ICardEdit | undefined | null) => {
    const tz = this.TazaConversion ?? 1;
    const round = (value: number) => Math.round(100 * value) / 100;
/*
    this.changePagado(round((data?.operacionpago?.montousd??0) * tz), data!, t);
    this.changeCuotasRecargo(round((data?.operacionpago?.cuotasrecargo??0) * tz), data!, t);
    this.changeComision(round((data?.operacion?.totaldescuentocomisionusd??0) * tz), data!, t);
    this.changeDescuentoVendedor(round((data?.operacion?.totaldescuentovendedorusd??0) * tz), data!, t);
    this.changeComision(round((data?.operacion?.totaldescuentocomisionusd??0) * tz), data!, t);*/
    this.onUpdateFields([ 
      { field: `operacionpago.idmoneda`, value: idMoneda },
      { field: `operacionpago.monto`, value: round((data?.operacionpago?.montousd??0) * tz) },
      { field: `operacionpago.cuotasrecargo`, value: round((data?.operacionpago?.cuotasrecargousd??0) * tz) },
      { field: `operacion.totaldescuentocomision`, value: round((data?.operacion?.totaldescuentocomisionusd??0) * tz) },
      { field: `operacion.totaldescuentovendedor`, value: round((data?.operacion?.totaldescuentovendedorusd??0) * tz) },
      { field: `operacion.totalajusteredondeo`, value: round((data?.operacion?.totalajusteredondeousd??0) * tz) },
    ]);
  }
}
